import React from 'react';
import CaseChat from '../../../Components/CaseChat/CaseChat';
import { useAppContext } from '../../../Services/AppContext';

interface Props {
	caseId: string;
}

const CaseChatPreview: React.FC<Props> = ({ caseId }) => {
	const { userData } = useAppContext();
	return <CaseChat userId={userData.id} caseId={caseId} isPreview />;
};

export default CaseChatPreview;
